import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-2xs font-medium uppercase tracking-wide leading-none whitespace-nowrap',
  {
    variants: {
      tone: {
        navy:     'border-navy-200 bg-navy-100 text-navy-800',
        slate:    'border-slate-200 bg-slate-50 text-slate-600',
        positive: 'border-positive/30 bg-positive-soft text-positive',
        warning:  'border-warning/30  bg-warning-soft  text-warning',
        info:     'border-info/30     bg-info-soft     text-info',
        // Red is NEGATIVE only — never decorative.
        negative: 'border-negative/30 bg-negative-soft text-negative',
      },
    },
    defaultVariants: { tone: 'slate' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, tone, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ tone }), className)} {...props} />
  ),
)
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
